import { Dialog, DialogContent, DialogContentText, DialogTitle, IconButton } from "@mui/material"
import { ReactNode, useContext } from "react"
import CloseIcon from '@mui/icons-material/Close'
import { rootContext } from "../contexts/rootContext"

interface SupaLinkDialogProps {
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  title: string
  titleColor: string
  content: ReactNode
  showX?: boolean
}

function SupaLinkDialog(props: SupaLinkDialogProps) {
  const context = useContext(rootContext)

  return (
    <Dialog
        open={props.open}
        onClose={(_event, reason) => {
          if (reason === "backdropClick") {
            return
          }

          props.setOpen(false)
        }}
        sx={{
          "& .MuiDialog-paper": {
            backgroundColor: context.theme.background,
            border: `${context.theme.text.contrast3} solid 2px`
          }
        }}
        slots={{
          // @ts-ignore
          backdrop: ""
        }}
      >
        <DialogTitle 
          sx={{ 
            m: 0, 
            paddingTop: 2,
            paddingLeft: 2,
            paddingBottom: 2,
            paddingRight:"50px", 
            fontFamily: context.theme.font,
            color: props.titleColor
          }}
        >
          {props.title}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={()=>props.setOpen(false)}
          sx={({
            visibility: props.showX === false ? "hidden" : "visible",
            position: 'absolute',
            right: 8,
            top: 8,
            color: context.theme.text.contrast4,
            cursor: `url(${context.theme.cursor.pointer}), default`
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent sx={{
          paddingTop: "0px",
          scrollbarColor: `${context.theme.text.contrast4} ${context.theme.background}`,
        }}>
          <DialogContentText 
            sx={{
              fontFamily: context.theme.font,
              color: context.theme.text.primary
            }}
          >
            {props.content}
          </DialogContentText>
        </DialogContent>
    </Dialog>)
}

export default SupaLinkDialog
